module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAOVJREFUOI21k0sOgzAMRMeoBzKfPfRkIScj7FuUE3W6CNACCR+pfVKkRHLGYzsBfoQAgGphINKeiHegWO8fLi6UlwTZAlmf1njVczLKfS12+2yzPpZpQrWogyM6CDrVaiGWHVezxPvBgmwh7FQLE3H0nb1qlpfnzM3XZTeWaqOOQuPZzQuvejTfhz7uoHnJtYsjVKtG85LT+XKPUmx6pFo1EJpYMACAdN4P9lAoBMsmcML7pzvlaO8t7XFq/GeSRXpUGAjTQomyI6UNFuMju8Ifxi80mpfpsW/g4hSEKPfPV7iEmzZvtCdgCNQAJ6cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliClass.png
// module id = 6Hf8
// module chunks = 1